import { formReducer, modelReducer } from 'react-redux-form'
import { combineReducers } from 'redux'

const initialEditModel = {
  title: '',
  url: '',
  cluster: [],
  tags: [],
  subTenant: null,
  active: true
}
const initialCalendarEventModel = {
  eventName: '',
  eventDescription: '',
  aboutTitle: '',
  descriptionTitle: '',
  location: '',
  eventDate: '',
  endDate: '',
  allDay: false,
  isApplication: false,
  currentlyAcceptingRsvp: false,
  maxRsvp: 0,
  rsvpTitle: '',
  rsvpButtonText: '',
  messagePostResponse: '',
  onScreenAcceptanceText: '',
  emailAcceptanceText: '',
  onScreenRejectionText: '',
  emailRejectionText: '',
  surveyId: -1
}

export default combineReducers({
  editForm: modelReducer('profileForms.editForm', initialEditModel),
  calendarEventForm: modelReducer(
    'profileForms.calendarEventForm',
    initialCalendarEventModel
  ),

  forms: formReducer('profileForms', {
    editForm: initialEditModel,
    calendarEventForm: initialCalendarEventModel
  })
})
